module.exports = __webpack_public_path__ + "img/best.96268d4d.png";